import { boolean } from 'yup'
import * as Yup from 'yup'
import {
  customerWebsiteUrlPattern,
  customerWebsiteValidationMessage,
  mandatoryFieldMessage,
  websiteValidationMessage,
} from './companyInfoValidation'

export const companyInfoSchema = Yup.object({
  companyName: Yup.string()
    .trim(mandatoryFieldMessage)
    .strict(true)
    .required(mandatoryFieldMessage),
  industry: Yup.string().required('Industry is required'),
  websiteURL: Yup.string()
    .matches(customerWebsiteUrlPattern, customerWebsiteValidationMessage)
    .required(websiteValidationMessage),
  acceptedTermsAndConditions: boolean()
    .isTrue()
    .required('Terms and conditions is required'),
})
